import { SnapshotIn, types } from 'mobx-state-tree'

import { center_app_version } from '../../version'

export const BackendVersionModel = types.model('BackendVersionModel', {
  backend_version: types.string,
})

export const ReleaseInfoModel = BackendVersionModel.named('ReleaseInfoModel').props({
  frontend_version: center_app_version.commit_sha,
})

export type BackendVersionSnapshot = SnapshotIn<typeof BackendVersionModel>
